import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0, n2 } from "../../lib/format";
import DataTable from "../../lib/DataTable";
import { Notice, Stat } from "../../lib/ui";

/* Products inventory – port of productlist.php (API: /api/products/all) */

export default function ProductList() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/products/all").then((r) => setRows(r.products)).catch((e) => setError(e.message)); }, [api]);
  const low = (rows || []).filter((p) => Number(p.quantity) < Number(p.minimum_stock || 0)).length;
  const out = (rows || []).filter((p) => Number(p.quantity) === 0).length;
  const value = (rows || []).reduce((s, p) => s + Number(p.quantity || 0) * Number(p.purchase_price || 0), 0);
  const cols = [
    { key: "product_id", label: "ID", num: true }, { key: "product_name", label: "Name", render: (p) => <b style={{ color: "var(--ink)" }}>{p.product_name}</b> },
    { key: "manufacturer", label: "Manufacturer" }, { key: "product_type", label: "Type" }, { key: "expiry_date", label: "Expiry", render: (p) => String(p.expiry_date || "–").slice(0, 10) },
    { key: "purchase_price", label: "Purchase", num: true, render: (p) => n2(p.purchase_price) }, { key: "retail_price", label: "Retail", num: true, render: (p) => n2(p.retail_price) },
    { key: "wholesale_price", label: "Wholesale", num: true, render: (p) => n2(p.wholesale_price) }, { key: "retail_unit", label: "R. unit" }, { key: "wholesale_unit", label: "W. unit" },
    { key: "wholesale_pack_size", label: "Pack", num: true }, { key: "minimum_stock", label: "Min", num: true },
    { key: "quantity", label: "Stock", num: true, render: (p) => <span style={{ fontWeight: 700, color: Number(p.quantity) === 0 ? "var(--danger)" : Number(p.quantity) < Number(p.minimum_stock || 0) ? "var(--warn)" : undefined }}>{n0(p.quantity)}</span> },
  ];
  return (
    <main className="pg" style={{ maxWidth: "100rem" }}>
      <PageHeader slug="productlist" actions={<Link to="/productAdd" className="btn primary"><i className="fas fa-plus" /> Add product</Link>} />
      <Notice notice={error && { tone: "err", text: error }} />
      {rows && <div className="ui-stats"><Stat icon="fa-box" label="Total products" value={n0(rows.length)} /><Stat icon="fa-triangle-exclamation" tone="warn" label="Below minimum" value={low} />
        <Stat icon="fa-box-open" tone="danger" label="Out of stock" value={out} /><Stat icon="fa-sack-dollar" tone="up" label="Inventory value (cost)" value={n0(value)} unit="TZS" /></div>}
      <section className="panel">{rows ? <DataTable columns={cols} rows={rows} rowKey={(p) => p.product_id} searchPlaceholder="Search products" empty="No products." />
        : !error && <div className="empty"><i className="fas fa-spinner fa-spin" />Loading…</div>}</section>
    </main>
  );
}
